const DEFAULT_SLUG = process.env.REACT_APP_MARKET_SLUG || 'default';

const RESERVED_SUBDOMAINS = new Set([
  'www',
  'api',
  'admin',
  'home',
  'dev',
  'platform',
]);

/**
 * Resolve the active market slug for the storefront.
 * Priority: env override → subdomain → default.
 */
export function getMarketSlug() {
  if (typeof window === 'undefined') {
    return DEFAULT_SLUG;
  }

  const host = window.location.hostname.toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1') {
    return DEFAULT_SLUG;
  }

  const parts = host.split('.');
  if (parts.length >= 3) {
    const sub = parts[0];
    if (!RESERVED_SUBDOMAINS.has(sub)) {
      return sub;
    }
  }

  return DEFAULT_SLUG;
}

export function getMarketHeaders() {
  return { 'X-Market-Slug': getMarketSlug() };
}
